// extracted by mini-css-extract-plugin
export default {"root":"SocialButton_root__JgbwR"};